import React, { useState, useEffect } from "react";
import { Link, useNavigate } from "react-router-dom";
import Sidebar from "../../Layouts/Sidebar";
import StatusBadge from "../../Reuseable/StatusBadge";
import DataParser from "../../../utlits/Dataparser";
import LeadSourceService from "../../../Services/LeadSourceService";

const LeadSource = () => {
  const [leadSources, setLeadSources] = useState([]);
  const [status, setStatus] = useState(true);
  const [name, setName] = useState("");
  const [editStatus, setEditStatus] = useState(null);
  const [editName, setEditName] = useState("");
  const [editId, setEditId] = useState("");
  const compids = DataParser.CompanyId();

  const onStatusChange = (e) => {
    setStatus(!status);
  };

  const onEditStatusChange = (e) => {
    setEditStatus(!editStatus);
  };

  const getLeadSource = () => {
    LeadSourceService.getLeadSourceAll(compids).then((res) => {
      const data = res.data.leadsources;
      setLeadSources(data);
    });
  };

  useEffect(() => {
    getLeadSource();
  }, []);

  const handelDelete = (e, item) => {
    e.preventDefault();
  };
  const handelEdit = (e, item) => {
    e.preventDefault();
    setEditId(item.id);
    setEditStatus(item.status);
    setEditName(item.name);
  };

  const handelUpdate = (e) => {
    e.preventDefault();
    let data = {
      name: editName,
    };
    const link = document.getElementById("editLeadSourceModal");
    LeadSourceService.updateLeadSource(editId, data).then((res) => {
      getLeadSource();
      link.click();
    });
  };

  const hadelCreate = (e) => {
    e.preventDefault();
    const link = document.getElementById("createLeadSourceModal");
    const data = {
      company_id: compids,
      name: name,
    };
    LeadSourceService.createLeadSource(data).then((res) => {
      getLeadSource();
      setName("");
      link.click();
    });
  };

  return (
    <>
      {/* <Sidebar /> */}
      <div className="main-content">
        <div className="page-content Pagebody">
          <div className="container-fluid">
            <div className="row">
              <div className="col-12">
                <div className="page-title-box d-flex align-items-center justify-content-between">
                  <h4 className="mb-0">All Lead Source </h4>
                  <div className="page-title-right">
                    <ol className="breadcrumb" style={{ marginBottom: "10px !important" }}>
                      <li className="breadcrumb-item">
                        <Link
                          to={`/${DataParser.CompanyIdentifierRole()}/home`}
                        >
                          Dashboard
                        </Link>
                      </li>
                      <li className="breadcrumb-item active">
                        {" "}
                        <Link
                          to={`/${DataParser.CompanyIdentifierRole()}/adminsettings`}
                        >
                          Settings
                        </Link>
                      </li>
                      <li className="breadcrumb-item active">Lead Source</li>
                    </ol>
                    <>
                      <button
                      style={{ float: "right" }}
                        type="button"
                        className="btn btn-primary waves-effect waves-light"
                        data-bs-toggle="modal"
                        data-bs-target="#createLeadSourceModal"
                      >
                        Create Lead Source
                      </button>

                      {/* Create modal content */}
                      <div
                        id="createLeadSourceModal"
                        className="modal fade"
                        tabIndex={-1}
                        role="dialog"
                        aria-labelledby="myModalLabel"
                        aria-hidden="true"
                      >
                        <div className="modal-dialog modal-dialog-centered">
                          <div className="modal-content">
                            <div className="modal-header">
                              <h5 className="modal-title" id="myModalLabel">
                                Create Lead Source
                              </h5>
                              <button
                                type="button"
                                className="btn-close"
                                data-bs-dismiss="modal"
                                aria-label="Close"
                              />
                            </div>
                            <div className="modal-body">
                              <div className="row">
                                <div className="col-12 mb-3 d-flex">
                                  <label
                                    className="form-label"
                                    style={{ paddingRight: "20px" }}
                                    htmlFor="Name"
                                  >
                                    Name
                                  </label>
                                  <input
                                    type="text"
                                    className="form-control"
                                    id="Name"
                                    placeholder="Title"
                                    required
                                    value={name}
                                    onChange={(e) => setName(e.target.value)}
                                  />
                                </div>
                                {/* <div className="col-12 mb-3 d-flex">
                                  <label
                                    className="form-label"
                                    style={{ paddingRight: "20px" }}
                                    htmlFor="Name"
                                  >
                                    Status
                                  </label>
                                  <div
                                    className="form-check form-switch form-switch-md mb-3"
                                    dir="ltr"
                                  >
                                    <input
                                      type="checkbox"
                                      className="form-check-input"
                                      id="customSwitchsizemd"
                                      onChange={(e) => onStatusChange(e)}
                                      defaultChecked={status}
                                    />
                                  </div>
                                </div> */}
                              </div>
                            </div>
                            <div className="modal-footer">
                              <button
                                type="button"
                                className="btn btn-light waves-effect"
                                data-bs-dismiss="modal"
                              >
                                Close
                              </button>
                              <button
                                type="button"
                                className="btn btn-primary waves-effect waves-light"
                                onClick={(e) => hadelCreate(e)}
                              >
                                Save changes
                              </button>
                            </div>
                          </div>
                          {/* /.modal-content modal-dialog-centere */}
                        </div>
                        {/* /.modal-dialog */}
                      </div>
                      {/* /.modal */}
                    </>
                  </div>
                </div>
              </div>
              <div className="col-lg-12">
                <div className="card">
                  <div className="card-body">
                    <div className="table-responsive">
                      <table className="table mb-0 table-striped">
                        <thead>
                          <tr className="tableHeaderbg">
                            <th>Sr#</th>
                            <th>Name</th>
                            <th>Status</th>
                            <th>Action</th>
                          </tr>
                        </thead>
                        <tbody>
                          {leadSources &&
                            leadSources.map((item, index) => (
                              <tr key={item.id}>
                                <th className="tableset" scope="row">
                                  {index + 1}
                                </th>
                                <th className="tableset">{item.name}</th>
                                <th className="tableset">
                                  <StatusBadge
                                    item={item}
                                    api={LeadSourceService.statusChange}
                                  />
                                </th>
                                <th className="tableset">
                                  <Link
                                    to="#"
                                    className="cursor-pointer iconscolor"
                                    onClick={(e) => handelDelete(e, item)}
                                  >
                                    <i className="uil-trash iconscolor" />
                                  </Link>

                                  <Link
                                    to="#"
                                    className="cursor-pointer iconscolor"
                                    onClick={(e) => handelEdit(e, item)}
                                  >
                                    <i
                                      className="uil-pen iconscolor"
                                      data-bs-toggle="modal"
                                      data-bs-target="#editLeadSourceModal"
                                    />
                                  </Link>
                                </th>
                              </tr>
                            ))}
                          {/* edit modal content */}
                          <div
                            id="editLeadSourceModal"
                            className="modal fade"
                            tabIndex={-1}
                            role="dialog"
                            aria-labelledby="myModalLabel"
                            aria-hidden="true"
                          >
                            <div className="modal-dialog modal-dialog-centered">
                              <div className="modal-content">
                                <div className="modal-header">
                                  <h5 className="modal-title" id="myModalLabel">
                                    Edits Lead Source
                                  </h5>
                                  <button
                                    type="button"
                                    className="btn-close"
                                    data-bs-dismiss="modal"
                                    aria-label="Close"
                                  />
                                </div>
                                <div className="modal-body">
                                  <div className="row">
                                    <div className="col-12 mb-3 d-flex">
                                      <label
                                        className="form-label"
                                        style={{ paddingRight: "20px" }}
                                        htmlFor="Name"
                                      >
                                        Name
                                      </label>
                                      <input
                                        type="text"
                                        className="form-control"
                                        id="Name"
                                        placeholder="Title"
                                        required
                                        value={editName}
                                        onChange={(e) =>
                                          setEditName(e.target.value)
                                        }
                                      />
                                    </div>
                                    {/* <div className="col-12 mb-3 d-flex">
                                      <label
                                        className="form-label"
                                        style={{ paddingRight: "20px" }}
                                        htmlFor="Name"
                                      >
                                        Status
                                      </label>
                                      <div
                                        className="form-check form-switch form-switch-md mb-3"
                                        dir="ltr"
                                      >
                                        <input
                                          type="checkbox"
                                          className="form-check-input"
                                          id="customSwitchsizemd"
                                          onChange={(e) =>
                                            onEditStatusChange(e)
                                          }
                                          defaultChecked={editStatus}
                                        />
                                      </div>
                                    </div> */}
                                  </div>
                                </div>
                                <div className="modal-footer">
                                  <button
                                    type="button"
                                    className="btn btn-light waves-effect"
                                    data-bs-dismiss="modal"
                                  >
                                    Close
                                  </button>
                                  <button
                                    type="button"
                                    className="btn btn-primary waves-effect waves-light"
                                    onClick={(e) => handelUpdate(e)}
                                  >
                                    Save changes
                                  </button>
                                </div>
                              </div>
                              {/* /.modal-content */}
                            </div>
                            {/* /.modal-dialog */}
                          </div>
                          {/* /.modal */}
                        </tbody>
                      </table>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default LeadSource;
